export function wasPortfolioItemRemoved({ prevRemovedCartItemId, removedPortfolioCartItemId }) {
    return !!removedPortfolioCartItemId && prevRemovedCartItemId !== removedPortfolioCartItemId;
}

export function isCartPage() {
    return typeof window !== 'undefined' && window.location.pathname.includes('/my/cart');
}
